import { useLanguage } from "@/context/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div className="relative overflow-hidden bg-brand py-4" data-testid="editorial-marquee">
      <div className="animate-marquee-drift flex w-max items-center gap-10 whitespace-nowrap">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-sm font-bold uppercase tracking-[0.3em] text-white">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
